import { render, staticRenderFns } from "./ReportePostulacionIndex.vue?vue&type=template&id=55e9d63a"
import script from "./ReportePostulacionIndex.vue?vue&type=script&lang=js"
export * from "./ReportePostulacionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports